module.exports = __webpack_public_path__ + "static/img/loading_iSpt.788745a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history/common/loading_iSpt.png
// module id = 11gh
// module chunks = 319